import React from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from 'react-apollo'

import { useConfig } from '../../../hooks/use-config'
import { useMyList } from '../../../hooks/use-my-list'
import {
  checkQueryStatus,
  isContentItemOnMyList
} from '../../../lib/utils'
import { getConfigValue } from '../../../utils/getConfigValue'
import { segmentTrackCancelJourney } from '../../../segment/segment-track'
import { LoadingModal as LoadingPanel } from '../../loading/modal'
import { CANCEL_JOURNEY_BUTTONS } from '../../../segment/constants'
import { MANAGE_PLAN_OPTIONS, ACCOUNT_SCREENS, CANCEL_SUBSCRIPTION_SCREENS } from '../../../constants'
import ACCOUNT_QUERY_WITH_DIR from '../../../../graphql/queries/account-with-directives.gql'
import COMPONENT_QUERY from '../../../../graphql/queries/component.gql'

import styles from '../cancel-subscription.css'
import SubscriptionInfo from './subscription-info'
import CancelCard from './cancel-card'
import ChangePlanCard from './change-plan-card'
import Carousel from './carousel'
import Button from '../../button'

function SubscriptionContent() {
  const history = useHistory()
  const { addToMyList } = useMyList()
  const { appConfig, configLoading } = useConfig()
  const configValues = appConfig.values
  const componentId = getConfigValue(configValues, 'CANCEL_JOURNEY_LANDING_CAROUSEL_COMPONENT_ID')

  const accountQuery = useQuery(ACCOUNT_QUERY_WITH_DIR, {
    variables: {
      withSubscription: true,
      withClearCachedSubscriptions: true
    },
    fetchPolicy: 'network-only'
  })

  const componentQuery = useQuery(COMPONENT_QUERY, {
    variables: {
      componentId
    },
    skip: !componentId
  })

  if (
    configLoading ||
    !componentId ||
    checkQueryStatus(accountQuery) ||
    checkQueryStatus(componentQuery)
  ) {
    return <LoadingPanel />
  }

  const activeSubscription = accountQuery.data?.account?.subscription
  const hasCancelOption = activeSubscription?.manageSubsOptions?.includes(MANAGE_PLAN_OPTIONS.CANCEL)
  if (!activeSubscription || !hasCancelOption) {
    history.push(ACCOUNT_SCREENS.SUBSCRIPTION_PAYMENT.path)
  }

  const hasChangePlanOption = activeSubscription.manageSubsOptions.includes(MANAGE_PLAN_OPTIONS.UPGRADE) || activeSubscription.manageSubsOptions.includes(MANAGE_PLAN_OPTIONS.DOWNGRADE)

  const cta = 'RETURN TO WATCHING NEON'
  const onClickHandler = () => {
    history.push('/')

    // Track cancel journey event
    segmentTrackCancelJourney({
      step: CANCEL_SUBSCRIPTION_SCREENS.CANCEL_SUBSCRIPTION_LANDING.name,
      buttonClicked: CANCEL_JOURNEY_BUTTONS.RETURN_TO_WATCH
    })
  }

  return (
    <>
      <SubscriptionInfo activeSubscription={activeSubscription} />
      <CancelCard activeSubscription={activeSubscription} />
      {hasChangePlanOption && (
        <ChangePlanCard activeSubscription={activeSubscription} />
      )}
      {componentQuery.data.component?.tiles && (
        <Carousel
          carousel={componentQuery.data.component}
          isContentItemOnMyList={(contentItemId) => isContentItemOnMyList(contentItemId)}
          addToMyList={addToMyList}
        />
      )}
      <div className={styles.buttonWrapper}>
        <Button
          className={styles.button}
          onClick={onClickHandler}
          text={cta}
          secondary
        />
      </div>
    </>
  )
}

export default SubscriptionContent
